<template>
  <div class="flex flex-col gap-2 text-base-content/50">
    <img :src="animation?.url" alt="frame" crossorigin="anonymous" />
  </div>
</template>

<script setup lang="ts">
import { MateSpriteAnimation } from "@/types/game";
import { onMounted, PropType, ref } from "vue";

const props = defineProps({
  animations: {
    type: Array as PropType<MateSpriteAnimation[]>,
    required: true,
  },
});

const animation = ref<Media>();

onMounted(() => {
  props.animations.forEach((_animation) => {
    if (_animation.action === 1 && _animation.direction === 2) {
      animation.value = _animation.media;
    }
  });
});
</script>
